<video #videoPlayer id="background-video-tutorial" class="video-js vjs-default-skin"></video>
